import Vue from 'vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueGtag from "vue-gtag";
import VeeValidate from 'vee-validate'
import Notifications from 'vue-notification'
import App from './App.vue'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false;
Vue.config.devtools = true;


Vue.use(VeeValidate);
Vue.use(Notifications);

Vue.use(VueGtag, {
  config: { id: "UA-1234567-1" }
});


new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')

